(function(angular) {
    THF.Angular.LiveQuoteTool.directive("inputLimit", [function() {
        return {
            restrict: "A",
            scope: {
                ngModel: '='
            },
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.inputLimit);
                var regex = attrs.inputLimitRegex;

                var allowedKeys = [
                    9, // Tab
                    8, // Backspace
                    46, // Delete
                    17, // Ctrl
                    18 // Alt
                ];

                if( typeof regex !== 'undefined' && regex !== '') {

                    angular.element(elem).on("keypress", function (e) {
                        var REGEX = new RegExp(regex);

                        var validKey = REGEX.test(String.fromCharCode(e.which));
                        if( allowedKeys.indexOf(e.which) === -1 && !validKey ) {
                            e.preventDefault();
                        }
                    });
                }

                if (limit > 0) {
                    angular.element(elem).on("keypress", function (e) {
                        if (allowedKeys.indexOf(e.which) === -1 && this.value.length >= limit) {
                            e.preventDefault();
                        }
                    });
                }

            }
        }
    }]);
})(angular);